import * as actions from './actions';
import reducers from './reducer';

export const Post = { actions, reducers };
export { PostState } from './reducer';
